/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { CpdsDatepickerItemProps, StyledTagProps } from '../typings';
import { themeToken } from '../../utils/cpds-utils';

export const DatePickerPopupButtonContainer = styled.div.attrs({
  'data-cy': 'datepickerpopupbuttoncontainer',
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 20px;
  gap: 20px;
  margin-top: auto;
  button {
    max-height: 40px;
    height: 40px;
  }
`;

export const DatePickerPopupSeperator = styled.div.attrs({
  'data-cy': 'datepickerpopupseperator',
})`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      height: 24px;
      position: relative;
      width: 100%;
      &:after {
        position: absolute;
        content: '';
        height: 1px;
        top: 50%;
        transform: translateY(-50%);
        left: ${token?.spacing?.space_16};
        right: ${token?.spacing?.space_16};
        background-color: ${token?.datepicker_seperator_color_mobile};
      }
    `;
  }}
`;

export const DatePickerPopupOptions = styled.div.attrs({
  'data-cy': 'datepickerpopupoptions',
  className: 'cpds-meta-roman-medium-book-09',
})`
  .cpds-drop-down-item {
    padding: 12px 16px;
    display: flex;
    align-items: center;
    max-height: 40px;
    gap: 8px;
    .cpds-drop-down-item-leading {
      width: 16px;
      height: 16px;
      svg {
        width: 12px;
        height: 9px;
      }
    }
    .cpds-drop-down-item-link {
      padding: 0;
    }
  }
`;

export const DatePickerPopupCloseButton = styled.button.attrs({
  'data-cy': 'datepickerpopupclosebutton',
})`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      background-color: unset;
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid ${token?.datepicker_close_btn_border_color_mobile};
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: 10px;
        height: 10px;
        path {
          fill: ${token?.datepicker_close_btn_icon_color_mobile};
        }
      }
    `;
  }}
`;

export const DatePickerPopupActionHeader = styled.div.attrs({
  'data-cy': 'datepickerpopupactionheader',
})`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      padding: 0 ${token?.spacing?.space_16} 0px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      height: 60px;
    `;
  }}
`;

export const DatePickerPopupOptionList = styled.div.attrs({
  'data-cy': 'datepickermobileoptionlist',
  className: 'date-picker-mobile-option-list',
})`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      bottom: 0;
      z-index: 9999;
      background-color: ${token?.datepicker_bg_color_mobile};
      display: none;
      box-shadow: 0px 2px 10px 0px #00000012;
      .uitk-cal-controls {
        max-width: 390px;
        margin: 0 auto;
        width: 100%;
        .uitk-cal-controls-parent-outset-single {
          margin: 0 px;
          padding: 0px 16px;
        }
        .uitk-cal-controls-button-outset {
          inset-block-start: 2%;
          width: 24px;
          height: 24px;
          button {
            width: 24px;
            height: 24px;
            block-size: unset;
            inline-size: unset;
            min-block-size: unset;
            &:before {
              width: 24px;
              height: 24px;
            }
            svg {
              width: 24px;
              height: 24px;
            }
          }
        }
        .uitk-cal-controls-button-prev {
          inset-inline-start: 22px;
        }
        .uitk-cal-controls-button-next {
          inset-inline-end: 22px;
        }
      }
    `;
  }}
`;

const colorMapper = (cpds) => {
  return {
    CLOSED: {
      color: cpds.drop_down_closed_color,
    },
    OPEN: {
      color: cpds.drop_down_open_color,
    },
    DISABLED_LIGHT: {
      color: cpds.drop_down_disabled_color,
    },
    APPLIED_LIGHT: {
      color: cpds.drop_down_applied_color,
      fontWeight: cpds.drop_down_applied_font_weight,
    },

    // CLOSED_DARK: {
    //   color: cpds.drop_down_color,
    // },
    // OPEN_DARK: {
    //   color: cpds.drop_down_color,
    // },
    // DISABLED_DARK: {
    //   color: cpds.drop_down_color,
    // },
    // APPLIED_DARK: {
    //   color: cpds.drop_down_color,
    //   fontWeight:cpds.drop_down_applied_font_weight
    // },
  };
};

const CpdsDatePickerStyleTag = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    isOpen = false,
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      position: relative;
      display: inline-block;
      ${isOpen
        ? css`
            .cpds-drop-down-items {
              display: block;
            }
            .date-picker-mobile-option-list {
              display: block;
            }
          `
        : ``}

      .uitk-cal-controls-parent-outset-single {
        margin-inline: 0;
        padding-inline: 0;
        .uitk-calendar-day-selection-edge-start {
          border-radius: 998px 0px 0px 999px;
          background-color: ${token.datepicker_select_color};
        }
        .uitk-calendar-day-selection-edge-end {
          border-radius: 0px 999px 999px 0px;
          background-color: ${token.datepicker_select_color};
        }

        .uitk-date-number-today{
          background-color: ${token.datepicker_select_color};
          color: #ffffff;
        }

        .uitk-calendar-day-selection-in-range,
        .uitk-calendar-day-selection-edge-unconfirmed-same-day,
        .uitk-calendar-day-selection-in-range-last-of-month,
        .uitk-calendar-day-selection-in-range-first-of-month {
          background-color: ${token.datepicker_select_color};
          background: ${token.datepicker_select_color};
          .uitk-date-number {
            color: #ffffff;
          }          
        }
      }

      .uitk-cal-controls-button-outset {
        inset-block-start: 3%;

        .uitk-button-paging {
          background-color: unset;
          border: unset;
          box-shadow: unset;
        }
      }

      ${(props) => props.styleOverrides || ''}
    `;
  }}
`;

const CpdsDatePickerButton = styled.button<StyledTagProps>`
  ${({
    theme: {
      styles: { cpds },
    },
    isOpen = false,
    ...props
  }) => {
    const { token, themeColorMode } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const state = props?.state || 'CLOSED';
    return css`    
      background-color: unset;
      color: ${colorMapper(token)?.[`${state}`]?.color || token.drop_down_closed_color};
      border: none;
      border-radius:unset;
      cursor: pointer;
      width:100%;
      padding-bottom: 4px;

      ${
        state === 'APPLIED'
          ? `
        border-bottom: 2px solid ${token.drop_down_applied_border_color};
        `
          : ``
      }
      }

      ${
        isOpen
          ? css`
              svg {
                transform: rotate(180deg);
              }
            `
          : ``
      }
      
     

      // &::after {
      //   content: "";
      //   position: absolute;
      //   right: 10px;
      //   top: 50%;
      //   width: 14px;
      //   height: 14px;
      //   background: url('https://mesocp3.azureedge.net/media/zpeppi1l/dropdown.svg') no-repeat center center;
      //   background-size: contain;
      //   transform: rotate(0deg) translateY(-50%);
      //   transition: transform 0.3s ease-in-out;
      //   ${themeColorMode === 'DARK' ? `filter: invert(1);` : ``}
      // }
    ${(props) => props.styleOverrides || ''}
  `;
  }}
`;

const CpdsDatePickerItems = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    isCalendar = false,
    ...props    
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const containerheight = props.maxItemsToShow || 0;
    return css`
      ${containerheight > 0 ? `height:calc(${containerheight} * ${token.drop_down_item_height});` : ``}
      display: none;
      position: absolute;
      padding: ${token.drop_down_wrapper_padding};
      width: max-content;
      min-width: ${isCalendar ? '312px' : '242px'};
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      z-index: 1;
      background-color: #ffffff;

      ${(props) => props.styleOverrides || ''}
    `;
  }}
`;

const CalenderContiner = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const containerheight = props.maxItemsToShow || 0;
    return css`
      max-height: max-content;
      margin: 12px 16px;
      display: flex;
      flex-direction: column;
      ${(props) => props.styleOverrides || ''}
    `;
  }}
`;

const CpdsDatePickerItem = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    selected = false,
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      display: flex;
      flex-direction: row;
      height: ${token.drop_down_item_height};
      color: ${token.drop_down_item_color};
      background-color: ${selected ? token.datepicker_option_item_selected_color : 'transparent'};
      &:hover {
        background-color: ${token.datepicker_option_item_selected_color};
      }
      .cpds-drop-down-item-leading {
        svg {
          path {
            fill: ${token?.datepicker_option_item_color};
          }
        }
      }
      .cpds-drop-down-item-trailing {
        svg {
          path {
            fill: ${token?.datepicker_trailling_icon_color};
          }
        }
      }
      ${(props) => props.styleOverrides || ''}
    `;
  }}
`;

const CpdsDatePickerItemLeading = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${token.drop_down_item_img_width};
      ${(props) => props.styleOverrides || ''}
    `;
  }}
`;

const CpdsDatePickerItemTrailing = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${token.drop_down_item_img_width};
      ${(props) => props.styleOverrides || ''}
    `;
  }}
`;

const CpdsDatePickerItemImg = styled.div<CpdsDatepickerItemProps>`
  ${({
    theme: {
      styles: { cpds },
    },
    ItemLeading,
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      width: 100%;
      height: 100%;
      background: url(${ItemLeading}) no-repeat;
      ${(props) => props.styleOverrides || ''}
    `;
  }}
`;

const CpdsDatePickerItemLink = styled.a`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      text-decoration: none !important;
      flex: 1;
      color: ${token?.datepicker_option_item_color};
      padding: ${token.drop_down_item_padding};

      ${(props) => props.styleOverrides || ''}
    `;
  }}
`;

export {
  CpdsDatePickerStyleTag,
  CpdsDatePickerButton,
  CpdsDatePickerItems,
  CpdsDatePickerItem,
  CpdsDatePickerItemLeading,
  CpdsDatePickerItemTrailing,
  CpdsDatePickerItemImg,
  CpdsDatePickerItemLink,
  CalenderContiner,
};
